import { render, staticRenderFns } from "./lotteryRecord.vue?vue&type=template&id=3d22cbe4&scoped=true&lang=pug&"
import script from "./lotteryRecord.vue?vue&type=script&lang=js&"
export * from "./lotteryRecord.vue?vue&type=script&lang=js&"
import style0 from "./lotteryRecord.vue?vue&type=style&index=0&id=3d22cbe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22cbe4",
  null
  
)

export default component.exports